import ReactHtmlParser from "@/src/utils/html-parser";
import { Box } from "@mui/material";
import type Affiliation from "@/src/_types/Authors/affiliation";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";

const AuthorAffiliation = ({
  affiliations,
}: {
  affiliations: Affiliation[];
}) => {
  return (
    <Box
      sx={{
        color: "text.primary",
        fontSize: ".8rem",
        pt: 0.5
      }}>
      {affiliations.map(
        (affiliation: Affiliation) =>
          affiliation.content &&
          affiliation.content !== "" && (
            <Box
              id={affiliation.id}
              key={`affiliation-${affiliation.id}`}
              sx={{
                display: "flex",
                alignItems: "baseline",
                mb: 0.0625,
                lineHeight: 1.4,
              }}>
              <SpanTypography
                sx={{
                  color: "custom.kicker",
                  fontSize: "0.6875rem",
                  fontWeight: 700,
                  mr: 0.375,
                  minWidth: "0.875rem",
                  display: "inline-block",
                  fontVariantNumeric: "tabular-nums",
                }}>
                {affiliation.label}
              </SpanTypography>

              <SpanTypography sx={{
                fontSize: ".875rem"
              }}>
                {ReactHtmlParser(affiliation.content)}
              </SpanTypography>
            </Box>
          ),
      )}
    </Box>
  );
};

export default AuthorAffiliation;
